import axios from "axios";
import { toast } from "react-toastify";
import getApi from "../utils/getApi";

const apiClient = axios.create({
  baseURL: getApi(),
});

apiClient.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    console.log(error);
    toast.error("An unexpected error occured");
  }

  if (expectedError && error.response.data === "Invalid token.") {
    console.log(error);
    // return (window.location = "/logout");
  }

  return Promise.reject(error);
});

function setToken(jwt) {
  apiClient.defaults.headers.common["x-auth-token"] = jwt;
}

export default {
  get: apiClient.get,
  post: apiClient.post,
  put: apiClient.put,
  patch: apiClient.patch,
  delete: apiClient.delete,
  setToken,
};
